import type { Dispatch } from 'react'

import type { PageLogger } from '../../../../../bi/mfi'
import { onboardingSelected } from '../../../../../bi/onboarding'
import { BusinessTermService } from '../../api/BusinessTermService'
import { getSuggestList } from '../getSuggestList'
import type { Action, SearchSource, State } from '../types'

type SelectCategoryParams = {
  dispatch: Dispatch<Action>
  displayName: string
  search?: string
  categories: State['categories']
  pageLogger: PageLogger
  questionKey: string
  businessTermService: BusinessTermService
}

export const selectCategory = async (params: SelectCategoryParams) => {
  const { dispatch, displayName, search = '', categories, pageLogger, questionKey, businessTermService } = params
  const index = categories.findIndex(c => c.displayName === displayName)
  const businessTerm = categories[index]
  if (!businessTerm || !businessTerm.displayName) {
    return
  }

  const businessSegmentId = businessTerm.businessTermId
    ? await businessTermService.getBusinessSegmentIdByTermId(businessTerm.businessTermId || '')
    : undefined

  void pageLogger.clickAnswer({
    questionKey,
    buttonName: businessTerm.displayName,
    position: index + 1,
    suggestedOption: false,
  })

  const searchSource: SearchSource = 'select'

  void onboardingSelected({
    name: businessTerm.displayName,
    text: search || '',
    position: index + 1,
    suggestList: getSuggestList(searchSource),
  })

  const category: State['category'] = {
    businessTerm,
    businessSegmentId,
    search,
    searchSource,
    index,
  }

  dispatch({ type: 'selectCategory', category })
}
